// SPDX-FileCopyrightText: 2024 Sequent Tech <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { isString } from "@sequentech/ui-core";
export var sortFunction = function (a, b) {
    if (isString(a === null || a === void 0 ? void 0 : a.name) && isString(b === null || b === void 0 ? void 0 : b.name)) {
        return a.name.localeCompare(b.name);
    }
    return 0;
};
